<template>
    <form @submit.prevent="submit">

        <modal width="small">
            <modal-header>
                <translate>Lieferverzögerung melden</translate>
            </modal-header>
            <modal-content>
                <form-input id="reason" name="reason" :label="this.$gettext('Grund der Lieferverzögerung')" v-model="form.reason"
                            :error="form.errors.reason"/>

                <form-datepicker id="new_delivery_date" name="new_delivery_date" :label="this.$gettext('Neues Lieferdatum')"
                                 v-model:date="form.new_delivery_date" :error="form.errors.new_delivery_date" :min-date="minNewDeliveryDate" :max-date="maxNewDeliveryDate" />

                <p class="overline-1">
                    <translate>Rechtlicher Hinweis</translate>
                </p>
                <p>
                    <translate>Wir weisen Sie darauf hin, dass PART FACTORY unverzüglich informiert werden muss, wenn
                        der festgelegte Liefertermin nicht eingehalten werden kann. Ansonsten ist PART FACTORY
                        berechtigt, vom Vertrag zurückzutreten (s. Rahmenvertrag Ziffer IV, 1-4) und gegebenenfalls eine
                        Vertragsstrafe zu verhängen (s. Rahmenvertrag Ziffer VI).
                    </translate>
                </p>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Melden</translate></form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import {useForm} from '@inertiajs/vue3';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';

export default {
    name: 'ProducerLateDelivery',
    components: {ModalActions, ModalContent, ModalHeader, FormButton, FormInput, FormDatepicker, Modal},
    emit: ['closeDialog'],
    props: {
        producerOrder: Object,
    },
    data() {
        const form = useForm({
            reason: null,
            new_delivery_date: null,
        });

        return {form};
    },
    computed: {
        minNewDeliveryDate() {
            return this.$moment(this.producerOrder.delivery_date).businessAdd(Number(this.$page.props.factors.min_delayed_delivery_time))._d;
        },
        maxNewDeliveryDate() {
            return this.$moment(this.producerOrder.delivery_date).businessAdd(Number(this.$page.props.factors.max_delayed_delivery_time))._d;
        },
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('order.late-delivery', {'producerOrder': this.producerOrder.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        },
    }
};
</script>
